import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { ActionsLayout, LayoutModule, Orientation } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { LoggerService } from '../../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { DialogModule, WindowModule, WindowState } from '@progress/kendo-angular-dialog';
import { LabelModule } from '@progress/kendo-angular-label';
import { Subscription } from 'rxjs';
import { CasiEventService } from '../../casi-event.service';
import { User as UserModel } from '../../../models/models.lib';
import { TileItem } from '../../../common/obj.lib';

@Component({
  selector: 'casi-my-work',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    IconsModule,
    NavigationModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    WindowModule,
    LabelModule
  ],
  templateUrl: './my-work.component.html',
  styleUrl: './my-work.component.scss'
})
export class MyWorkComponent implements OnInit, OnDestroy, AfterContentInit {

  private _tile: TileItem | undefined;
  @Input({ required: true })
  set tile(value: TileItem) {
    this.logger.debug(`set tile: `, value);
    this._tile = value;
  }
  get tile() {
    return this._tile!;
  }

  private _users: UserModel[] = [];
  @Input({ required: true }) set users(value: UserModel[]) {
    this.logger.debug(`set users: `, value);
    this._users = value;
  }
  get users() {
    return this._users;
  }

  public showAdd: boolean = true;
  public title: string = 'My Work';
  public opened = true;
  public isDraggable = true;
  public windowState: WindowState = "default";
  public expanded = false;
  public liked = false;
  public btnText = "More";

  public actionsOrientation: Orientation = "horizontal";
  public actionsLayout: ActionsLayout = "end";

  public get horizontalStretched(): boolean {
    return (
      this.actionsOrientation === "horizontal" &&
      this.actionsLayout === "stretched"
    );
  }

  public toggleRecipe(): void {
    this.expanded = !this.expanded;
    this.btnText = this.expanded ? "Less" : "More";
  }

  public toggleLike(): void {
    this.liked = !this.liked;
  }

  public heartIcon(): string {
    return this.liked
      ? "k-icon k-font-icon k-i-heart"
      : "k-icon k-font-icon k-i-heart-outline";
  }

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private casiEventService: CasiEventService
  ) {
    faIcons.addIcons(...all);
  }

  //#region Ng Event Handlers

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
  }
  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }
  ngOnInit(): void {
    this.logger.debug('ngOnInit...',);
    this._subs.push(this.casiEventService.casiEvent$.subscribe((e) => {
      this.logger.debug(`ngOnInit:casiEvent: `, e);
    }));
  }

  //#endregion

  public openClose(isOpened: boolean): void {
    this.opened = isOpened;
  }

}
